import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getCompanyNoteListData } from './mockData'
import type { ICompanyNote } from '~/types/note/models'

export const {
  getNotes: getCompanyNotes,
  postNote: postCompanyNote,
  patchNote: patchCompanyNote,
  deleteNote: deleteCompanyNote,
  handlers,
} = makeNoteAPIs<ICompanyNote>({
  apiPathEntityNamePrefix: 'company',
  getNoteListDataFn: getCompanyNoteListData,
})
